import 'react';
import '../Provider/ThemeContext.js';
import 'classnames';
import 'emotion';
import '@emotion/core';
import 'emotion-theming';
import '@emotion/styled';
import { useTheme } from './useTheme.js';
import './useLocalStorage.js';
import { _ as _objectSpread2 } from '../chunk-1b90139e.js';
import './omit.js';
import '../ColorMode/utils.js';
import { useColorMode } from '../ColorMode/ColorModeContext.js';
import '../ColorMode/InitializeColorMode.js';
import { get } from './get.js';
import { omitBy } from './omitBy.js';

var isUndefined = function isUndefined(val) {
  return typeof val === 'undefined';
};

function getDefaultPropsFromTheme(theme, _ref) {
  var _theme$variants, _theme$variants$varia, _theme$modes, _theme$modes$colorMod;

  var colorMode = _ref.colorMode,
      variant = _ref.variant;
  var themeDefaultProps = (theme === null || theme === void 0 ? void 0 : theme.defaultProps) ? omitBy(theme.defaultProps, isUndefined) : {};
  var themeVariantDefaultProps = (theme === null || theme === void 0 ? void 0 : theme.variants) ? omitBy(((_theme$variants = theme.variants) === null || _theme$variants === void 0 ? void 0 : (_theme$variants$varia = _theme$variants[variant]) === null || _theme$variants$varia === void 0 ? void 0 : _theme$variants$varia.defaultProps) || {}, isUndefined) : {};
  var themeColorModeDefaultProps = (theme === null || theme === void 0 ? void 0 : theme.modes) ? omitBy(((_theme$modes = theme.modes) === null || _theme$modes === void 0 ? void 0 : (_theme$modes$colorMod = _theme$modes[colorMode]) === null || _theme$modes$colorMod === void 0 ? void 0 : _theme$modes$colorMod.defaultProps) || {}, isUndefined) : {};
  return {
    themeDefaultProps: themeDefaultProps,
    themeVariantDefaultProps: themeVariantDefaultProps,
    themeColorModeDefaultProps: themeColorModeDefaultProps
  };
}

function useDefaultProps(props, config) {
  var _config2, _config3;

  if (props === void 0) {
    props = {};
  }

  if (config === void 0) {
    config = {};
  }

  var _config = config,
      themeKey = _config.themeKey;

  var _useTheme = useTheme(),
      theme = _useTheme.theme;

  var _useColorMode = useColorMode(),
      globalColorMode = _useColorMode.colorMode;

  var colorMode = props.colorMode || globalColorMode;
  var configDefaultProps = ((_config2 = config) === null || _config2 === void 0 ? void 0 : _config2.defaultProps) ? omitBy((_config3 = config) === null || _config3 === void 0 ? void 0 : _config3.defaultProps, isUndefined) : {};

  var _getDefaultPropsFromT = getDefaultPropsFromTheme(get(theme, themeKey), {
    colorMode: colorMode,
    variant: props.variant
  }),
      themeDefaultProps = _getDefaultPropsFromT.themeDefaultProps,
      themeVariantDefaultProps = _getDefaultPropsFromT.themeVariantDefaultProps,
      themeColorModeDefaultProps = _getDefaultPropsFromT.themeColorModeDefaultProps;

  var _getDefaultPropsFromT2 = getDefaultPropsFromTheme(get(props, "overrides." + themeKey), {
    colorMode: colorMode,
    variant: props.variant
  }),
      overridesDefaultProps = _getDefaultPropsFromT2.themeDefaultProps,
      overridesVariantDefaultProps = _getDefaultPropsFromT2.themeVariantDefaultProps,
      overridesColorModeDefaultProps = _getDefaultPropsFromT2.themeColorModeDefaultProps;

  var newProps = _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, configDefaultProps), themeDefaultProps), themeVariantDefaultProps), themeColorModeDefaultProps), overridesDefaultProps), overridesVariantDefaultProps), overridesColorModeDefaultProps), {}, {
    colorMode: colorMode
  }, omitBy(props, isUndefined));

  return {
    props: newProps,
    themeKey: themeKey
  };
}

export { useDefaultProps };